import React, { memo } from 'react';
import { Container, Label } from './styles';
import FormikInput from '@acko-tech/building-blocks.ui.form';
import InputField from '../inputField';
import validate from 'utils/validate';
import RadioField from '../radioField';

const TrailerInputGroup = ({
    registrationNumber,
    chassisNumber,
    setTrailerInfo,
    registrationNumberError,
    chassisNumberError,
    typeError,
    setError,
    deleteError,
    showError,
    // setShowError,
    label,
    id,
    type,
}) => {
    const errors = {
        registrationNumber: registrationNumberError,
        chassisNumber: chassisNumberError,
        type: typeError,
    };

    const setShowError = () => {};

    return (
        <Container>
            <Label>{label}</Label>
            <FormikInput
                name="registrationNumber"
                initialValue={registrationNumber}
                validate={(values) => {
                    const registrationNumberErrors =
                        validate.registrationNumber(values);
                    if (registrationNumberErrors.registrationNumber) {
                        setError({
                            key: 'registrationNumber',
                            value: registrationNumberErrors.registrationNumber,
                            id,
                        });
                    } else {
                        deleteError({
                            key: 'registrationNumber',
                            id,
                        });
                    }
                    return registrationNumberErrors;
                }}
                value={registrationNumber}
                handleNext={() => null}
                buttonText=""
                validateOnBlur
                customInput={({ errors: formikErrors, ...props }: any) => (
                    <InputField
                        errors={{ ...errors, ...formikErrors }}
                        {...props}
                        showError={showError}
                        setShowError={setShowError}
                        placeholder="Registration number"
                        name="registrationNumber"
                        onChange={(value) => {
                            setTrailerInfo({
                                value: value?.toUpperCase(),
                                key: 'registrationNumber',
                                id,
                            });
                        }}
                        value={registrationNumber}
                        className="fs-exclude"
                    />
                )}
                enableReinitialize
            />
            <FormikInput
                name="chassisNumber"
                initialValue={chassisNumber}
                validate={(values) => {
                    const chassisNumberErrors = validate.chassisNumber(values);
                    if (chassisNumberErrors.chassisNumber) {
                        setError({
                            key: 'chassisNumber',
                            value: chassisNumberErrors.chassisNumber,
                            id,
                        });
                    } else {
                        deleteError({
                            key: 'chassisNumber',
                            id,
                        });
                    }
                    return chassisNumberErrors;
                }}
                value={chassisNumber}
                handleNext={() => null}
                buttonText=""
                validateOnBlur
                customInput={({ errors: formikErrors, ...props }: any) => (
                    <InputField
                        errors={{ ...errors, ...formikErrors }}
                        {...props}
                        showError={showError}
                        setShowError={setShowError}
                        placeholder="Chassis number"
                        name="chassisNumber"
                        onChange={(value) => {
                            setTrailerInfo({
                                value: value?.toUpperCase(),
                                key: 'chassisNumber',
                                id,
                            });
                        }}
                        value={chassisNumber}
                        className="fs-exclude"
                    />
                )}
                enableReinitialize
            />

            <RadioField
                field="Select trailer type"
                selectedValue={type}
                name={'isPreviousPolicyExpired'}
                setValue={(selection) => {
                    setTrailerInfo({
                        value: selection,
                        key: 'type',
                        id,
                    });
                }}
                options={[
                    { value: 'open', displayValue: 'Open' },
                    {
                        value: 'closed',
                        displayValue: 'Closed',
                    },
                ]}
                styles={{ padding: '8px 12px 1rem', border: 'unset' }}
            />
        </Container>
    );
};

export default memo(TrailerInputGroup);
